import { ToastProvider } from "@/ds";
import { useProfissionaisScreen } from "./use-profissionais";
import { ProfissionaisScreenView } from "./view-profissionais";

function ProfissionaisScreenLigada() {
  const vm = useProfissionaisScreen();

  return <ProfissionaisScreenView {...vm} />;
}

export function ProfissionaisScreen() {
  return (
    <ToastProvider position="top-right">
      <ProfissionaisScreenLigada />
    </ToastProvider>
  );
}

export type * from "./types-profissionais";
